import { Icon } from "./Icon.tsx";

/** "Map Query" icon — a funnel/filter glyph. */
export function MapQueryIcon() {
  return (
    <Icon>
      <path d="M4 5h16l-6 7.5V19l-4 2v-8.5Z" />
    </Icon>
  );
}
